export default "__VITE_ASSET__B_XD09lO__"